import React from 'react';
import glamorous from 'glamorous';
import { connect } from 'react-redux';
import { NavLink } from 'redux-first-router-link';

import { getLocationQuery } from '../reducers/location';
import * as routeTypes from '../routes/types';

import { palette } from '../styles';

const isProduction = process.env.NODE_ENV === 'production';

const navLinks = [
  {
    title: 'Policies',
    route: {
      type: routeTypes.ROUTE_POLICIES,
    },
  },
];

if (!isProduction) {
  navLinks.push({
    title: 'Demo',
    route: {
      type: routeTypes.ROUTE_DEMO,
    },
  });
}

const styleFooterLink = {
  marginRight: 16,
  color: palette.white.darkest,
  textDecoration: 'none',
  textTransform: 'uppercase',
};

const styleFooterLinkActive = {
  color: palette.white.base,
};

const typesMatch = (location, link) => location.type ===link.route.type;

const payloadsMatch = (location, link) => {
  let isMatch = true;

  const { payload } = link.route;

  if (payload && location.payload) {
    Object.keys(location.payload).forEach((key) => {
      if (isMatch) {
        isMatch = location.payload[key] === payload[key];
      }
    });
  }

  return isMatch;
};

const isActive = (location, link) => typesMatch(location, link) && payloadsMatch(location, link);

const FooterLinksContainer = glamorous.div({
  userSelect: 'none',
});

class FooterContainer extends React.PureComponent {
  renderFooterLink = (link) => {
    const to = {
      ...link.route,
      query: this.props.locationQuery,
    };

    return (
      <NavLink
        key={link.route.type}
        to={to}
        activeStyle={styleFooterLinkActive}
        style={styleFooterLink}
        exact={link.route.type === routeTypes.ROUTE_HOME}
        isActive={(match, location) => isActive(location, link)}
      >
        {link.title}
      </NavLink>
    );
  };

  render() {
    return (
      <FooterLinksContainer>
        {navLinks.map(this.renderFooterLink)}
      </FooterLinksContainer>
    );
  }
}

const mapStateToProps = state => ({
  locationQuery: getLocationQuery(state),
});

export default connect(mapStateToProps)(FooterContainer);



// WEBPACK FOOTER //
// ./src/containers/FooterContainer.js